import script from "./OidcConfiguration.vue?vue&type=script&lang=ts&setup=true"
export * from "./OidcConfiguration.vue?vue&type=script&lang=ts&setup=true"

import "./OidcConfiguration.vue?vue&type=style&index=0&id=6971aae8&scoped=true&lang=css"

import exportComponent from "/builds/javier-sedano/oidc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6971aae8"]])

export default __exports__